import type { Pet } from "../data/pets";
import { petDownloadPath } from "./pet-contract";

export function downloadPetArchive(pet: Pet): void {
  const anchor = document.createElement("a");
  anchor.href = petDownloadPath(pet);
  anchor.download = `${pet.id}.codex-pet.zip`;
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
}
